module.exports = __webpack_public_path__ + "static/media/shadowNotepad.c47da07f.png";